import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=1c0ce29c&"
import script from "./issue.vue?vue&type=script&lang=js&"
export * from "./issue.vue?vue&type=script&lang=js&"
import style0 from "./issue.vue?vue&type=style&index=0&id=1c0ce29c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports